import { combineReducers } from "@reduxjs/toolkit";
import { agroApi } from "../api/api";
import { AUTH_SLICE_KEY, authSlice } from "../slices/authSlice";
import { RootState } from "./root-state.interface";

export const rootReducer = combineReducers<RootState>({
    [agroApi.reducerPath]: agroApi.reducer,
    [AUTH_SLICE_KEY]: authSlice.reducer
})